<template>
	<div v-if="endUser && endUser.client" :class="`end-user data-euid-${endUser.id} data-clid-${endUser.client.id}`"
		:data-euid="endUser.id" :data-clid="endUser.client.id">
		<div v-if="ready">
			<PreStepNew :cards="newPresteps" v-if="newPresteps.length > 0" v-show="prestepOpen" />
			<PreStep :cards="oldPresteps" v-if="oldPresteps.length > 0" v-show="prestepOpen" />

			<div :class="[{ 'start-container': !showCarousel }, coachEffectClass]" v-show="!prestepOpen">
				<TopMenu v-if="!showCarousel" />
				<LanguagePicker v-if="showCarousel" />
				<Coach />
				<SideMenu v-if="hasMap" />
				<SideProfile v-if="endUser && hasGamification && !showCarousel" />
				<Map v-if="hasMap && !showCarousel" />
				<EnableMap v-if="!hasMap && canEnableMap" />
				<Infographic v-if="!hasMap" />
				<Cards v-if="!showCarousel" />
				<CarouselCards v-else />
				<Footer v-if="!showCarousel" />
			</div>

			<Cookies v-if="ready && endUser.client && endUser.client.id !== 27" />
		</div>
	</div>
</template>

<script>
import axios from 'axios'

import Map from '@/components/Map.vue'
import EnableMap from '@/components/EnableMap.vue'
import PreStepNew from '@/components/PreStepNew.vue'
import PreStep from '@/components/PreStep.vue'
import Cards from '@/components/Cards.vue'
import CarouselCards from '@/components/CarouselCards.vue'
import SideMenu from '@/components/SideMenu.vue'
import SideProfile from '@/components/SideProfile.vue'
import TopMenu from '@/components/TopMenu.vue'
import Footer from '@/components/Footer.vue'
import Coach from '@/components/Coach.vue'
import Cookies from '@/components/Cookies.vue'
import Infographic from '@/components/Infographic.vue'
import JsCookies from 'js-cookie'
import LanguagePicker from '@/components/LanguagePicker.vue'

export default {
	name: 'EndUser',

	components: {
		Map, Cards, SideMenu, SideProfile, TopMenu, Footer,
		Coach, PreStep, PreStepNew, Cookies, Infographic, EnableMap, CarouselCards, LanguagePicker
	},

	computed: {
		ready() {
			return !this.$store.state.loading
		},

		oldPresteps() {
			// Only show prestep cards from active layers (layers default to active, parseRules deactivates based on rules)
			const activeLayerIds = this.$store.state.layers
				.filter(l => l.active)
				.map(l => l.id)

			return this.$store.getters.cards
				.filter(c => c.type === 'prestep' && !c.hidden && !c.type_options.new_prestep_design
					&& activeLayerIds.includes(c.layer_id))
		},

		newPresteps() {
			const finishedPreStep = this.$getCookie('finishedPrestep')
			const forceReplayPreStep = this.$store.state.endUser.test_user || this.$route.query.rps || this.$store.state.client.always_show_prestep
			const forceFinishPreStep = this.$route.query.fnp
			if ((finishedPreStep && !forceReplayPreStep) || forceFinishPreStep) {
				return []
			}

			// Only show prestep cards from active layers (layers default to active, parseRules deactivates based on rules)
			const activeLayerIds = this.$store.state.layers
				.filter(l => l.active)
				.map(l => l.id)

			return this.$store.getters.cards
				.filter(c => c.type.includes('new_prestep_') && !c.hidden
					&& activeLayerIds.includes(c.layer_id) // Only include cards from active layers
					&& (!c.lang || c.lang === this.$store.state.endUser.language)
					&& (c.type !== 'new_prestep_language' || c.type === 'new_prestep_language' && !this.$route.query.lang)
					&& !(c.type === 'new_prestep_address' && !this.$store.state.endUser.googleMapsConsent)
					&& !(c.type === 'new_prestep_consent' && this.$getCookie('consentSlug') == this.$store.state.endUser.slug)
					&& !(c.id == 1597 && this.$store.state.endUser.tags.find(t => t.id == 1440))
				)
		},

		prestepOpen() {
			return this.$store.state.prestepOpen
		},

		hasMap() {
			return !this.$store.state.client.no_map && this.$store.state.mapsApi
		},

		canEnableMap() {
			return this.$store.state.client.no_map !== true
		},

		endUser() {
			return this.$store.state.endUser
		},

		hasGamification() {
			return this.$store.getters.cards
				.filter(c => (c.type === 'challenge' || c.type === 'quiz') && !c.hidden)
				.length > 0
		},

		coachEffectClass() {
			return this.$store.state.coachEffect
		},

		clientCustomization() {
			return this.$store.state.client.customization
		},

		showCarousel() {
			return this.$store.state.client.show_carousel
		}
	},

	mounted() {
		this.$store.state.loading = true

		let queryParams = { ...this.$route.query, api_token: this.$getCookie('resvana_at'), appHost: window.location.hostname }

		axios.post(this.$apiUrl + '/api/visit/' + this.$route.params.slug + '/App', {});

		axios
			.get(this.$apiUrl + '/api/end-user/' + this.$route.params.slug, { params: queryParams })
			.then(res => this.$store.commit('setup', res.data))
			.catch(e => {
				if (e.response?.status === 401) {
					this.$router.push({ name: 'Intro' })
				}

				if (e.response?.status === 404) {
					if (this.$route.params.slug == this.$getCookie('openEndUser')) {
						JsCookies.remove('openEndUser')
						JsCookies.remove('openEndUserHost')
					}

					this.$router.push({ name: 'Intro' })
				}
			})

		// Register external link clicks within cards
		document.addEventListener('click', e => {
			let card = e.target.closest('.card')

			if (card && e.target.tagName === 'A') {
				this.$metric({ 'event': 'external_link_interaction', 'CardTitle': card.getAttribute('data-card-title'), 'LinkHref': e.target.getAttribute('href') }, true)
			}
		})
	}
}
</script>
